export enum CustomerSizePriceMultiplier {
  PRIVATE = 0,
  SMALL = 1,
  MEDIUM = 2,
  LARGE = 3,
  ENTERPRISE = 99
}
